import {Config, registerBrick} from 'olympe';
import {ReactBrick, useProperty} from '@olympeio/core';
import React, {useEffect, useState} from 'react';
import {ezprOrange, useOlympeProperty} from './_helpers';
import {Box, Tooltip} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SvgIcon from '@mui/material/SvgIcon';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress';

const PreferredSupplierListIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="Preferred Supplier List">
        <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </SvgIcon>
);

const RequestCockpitIcon = (props) => (
    <SvgIcon
        {...props}
        viewBox="0 0 48.753 45.245"
        titleAccess="Request Cockpit"
    >
        <g transform="translate(-642.748 -339.5)">
            <path
                d="M-152.4,11266.122s-.034-2.887,0-5.24.822-5.027,3.978-7.631a12.908,12.908,0,0,1,8.646-2.782c2.233-.035,32.361,0,32.361,0"
                transform="translate(796.161 -10904)"
                fill="#F19001"
                stroke="white"
                strokeLinecap="round"
                strokeWidth="3"
            />
            <path
                d="M801-10898l-6,6Zm-6-6,6,6Z"
                transform="translate(-110.5 11244.5)"
                fill="#F19001"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
            />
            <path
                d="M-107.426,11250.452s.034,2.887,0,5.24-.822,5.027-3.978,7.631a12.908,12.908,0,0,1-8.646,2.782c-2.233.035-32.361,0-32.361,0"
                transform="translate(797.911 -10888.33)"
                fill="#F19001"
                stroke="white"
                strokeLinecap="round"
                strokeWidth="3"
            />
            <path
                d="M6,6,0,12ZM0,0,6,6Z"
                transform="translate(649.751 383.745) rotate(180)"
                fill="#F19001"
                stroke="white"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="3"
            />
            <g>
                <path
                    d="M-141.335,11256.9h4.751l3.846,12.821H-121.8l4.223-8.9H-129.8"
                    transform="translate(795 -10904)"
                    fill="#F19001"
                    stroke="white"
                    strokeLinecap="round"
                    strokeWidth="2.5"
                />
                <circle cx="1.5" cy="1.5" r="1.5" transform="translate(671 369)" fill="white" />
                <circle cx="1.5" cy="1.5" r="1.5" transform="translate(662 369)" fill="white" />
            </g>
        </g>
    </SvgIcon>
);

const BusinessApprovalIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="Business Approval">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
    </SvgIcon>
);

const ProcurementApprovalIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="Procurement Approval">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
    </SvgIcon>
);

const ConfigurationCockpitIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="Configuration Cockpit">
        <path d="M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z" />
    </SvgIcon>
);

const MRPIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="MRP">
        <path
            fill="none"
            transform="scale(1.2,1.2)"
            d="M0 0h20v20H0V0z"
        />
        <path
            transform="scale(1.2,1.2)"
            d="M15.95 10.78c.03-.25.05-.51.05-.78s-.02-.53-.06-.78l1.69-1.32c.15-.12.19-.34.1-.51l-1.6-2.77c-.1-.18-.31-.24-.49-.18l-1.99.8c-.42-.32-.86-.58-1.35-.78L12 2.34c-.03-.2-.2-.34-.4-.34H8.4c-.2 0-.36.14-.39.34l-.3 2.12c-.49.2-.94.47-1.35.78l-1.99-.8c-.18-.07-.39 0-.49.18l-1.6 2.77c-.1.18-.06.39.1.51l1.69 1.32c-.04.25-.07.52-.07.78s.02.53.06.78L2.37 12.1c-.15.12-.19.34-.1.51l1.6 2.77c.1.18.31.24.49.18l1.99-.8c.42.32.86.58 1.35.78l.3 2.12c.04.2.2.34.4.34h3.2c.2 0 .37-.14.39-.34l.3-2.12c.49-.2.94-.47 1.35-.78l1.99.8c.18.07.39 0 .49-.18l1.6-2.77c.1-.18.06-.39-.1-.51l-1.67-1.32zM10 13c-1.65 0-3-1.35-3-3s1.35-3 3-3 3 1.35 3 3-1.35 3-3 3z"
        />
    </SvgIcon>
);

const ContractsIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="Contracts">
        <path d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
    </SvgIcon>
);

const TenderCalendarIcon = (props) => (
    <SvgIcon {...props} viewBox="0 0 24 24" titleAccess="Tender Calendar">
        <path d="M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V8h16v13z" />
    </SvgIcon>
);

/**
 * This brick display a sidebar with useful links
 */
export default class Sidebar extends ReactBrick {
    /**
     * @override
     */
    static getReactComponent($) {
        return () => {
            const userEmail = localStorage.getItem('userEmail') || '';
            const userFullName = localStorage.getItem('userFullName') || '';
            const bearerToken = useProperty($, 'Bearer token');

            const [img, setImg] = useState(null);
            const [loading, setLoading] = useOlympeProperty($, 'Loading', true);
            const env = Config.getParameter('ENV');

            const initials = userFullName
                .split(' ')
                .filter(Boolean)
                .slice(0, 2)
                .map((name) => name[0].toUpperCase())
                .join('');

            useEffect(() => {
                $.trigger('Fetch Bearer Token');
            }, []);

            useEffect(() => {
                if (
                    !userEmail ||
                    userEmail === 'test.user@nestle.test' ||
                    !bearerToken
                ) {
                    return;
                }

                const fetchPhoto = async () => {
                    try {
                        const response = await fetch(
                            `https://graph.microsoft.com/v1.0/users/${userEmail}/photo/$value`,
                            {
                                headers: {
                                    'ConsistencyLevel': 'eventual',
                                    'Authorization': bearerToken,
                                },
                            },
                        );
                        if (!response.ok) {
                            console.error('Failed to fetch profile picture');
                            setImg(null);
                            return;
                        }
                        const blob = await response.blob();
                        setImg(URL.createObjectURL(blob));
                    } catch (error) {
                        console.error('Error fetching profile picture:', error);
                        setImg(null);
                    }
                };

                fetchPhoto();
            }, [userEmail, bearerToken]);

            const handleAvatarClick = () => {
                setLoading(true);
                $.trigger('Avatar Click');
            };

            let baseS2PURL; let baseAMCURL;
            switch (env) {
                case 'codev':
                    baseS2PURL = 'https://test.s2pbrowser.nestle.com/';
                    baseAMCURL = 'https://amc-codev.fluidapp.io/';
                    break;
                case 'preprod':
                    baseS2PURL = 'https://test.s2pbrowser.nestle.com/';
                    baseAMCURL = 'https://amc-preprod.fluidapp.io/';
                    break;
                default:
                    baseS2PURL = 'https://s2pbrowser.nestle.com/';
                    baseAMCURL = 'https://amc.fluidapp.io/';
            }

            const items = [
                {icon: <PreferredSupplierListIcon/>, url: `${baseS2PURL}pslCatalogs`, tooltipTitle: 'Preferred Supplier List'},
                {icon: <RequestCockpitIcon/>, url: `${baseS2PURL}document-flow`, tooltipTitle: 'Request Cockpit'},
                {icon: <BusinessApprovalIcon/>, url: `${baseS2PURL}business-approval`, tooltipTitle: 'Business Approval'},
                {icon: <ProcurementApprovalIcon/>, url: `${baseS2PURL}purchasing-approval`, tooltipTitle: 'Procurement Approval'},
                {icon: <ConfigurationCockpitIcon/>, url: baseAMCURL, tooltipTitle: 'Configuration Cockpit'},
                {icon: <MRPIcon/>, url: `${baseS2PURL}mrp`, tooltipTitle: 'MRP'},
                {icon: <ContractsIcon/>, url: `${baseS2PURL}contracts`, tooltipTitle: 'Contracts'},
                {icon: <TenderCalendarIcon/>, url: `${baseS2PURL}contract/appointments`, tooltipTitle: 'Tender Calendar'},
            ];

            return (
                <Box
                    component="nav"
                    sx={{
                        width: 52,
                        height: '100vh',
                        bgcolor: ezprOrange,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        pt: 2,
                    }}
                >
                    <Box mt={6}/>
                    {items.map(({icon, url, tooltipTitle}, i) => (
                        <Tooltip key={i} title={tooltipTitle} placement="bottom">
                            <IconButton
                                onClick={() =>
                                    window.open(url, '_blank')
                                }
                                sx={{
                                    'width': '100%',
                                    'color': '#fff',
                                    'height': 52,
                                    'borderRadius': 0,
                                    'p': 0,
                                    'mb': i < items.length - 1 ? 1 : 0,
                                    '&:hover': {
                                        backgroundColor: (theme) => theme.palette.action.hover,
                                        borderRadius: 0,
                                    },
                                }}
                            >
                                {icon}
                            </IconButton>
                        </Tooltip>
                    ))}

                    <Box
                        sx={{
                            mt: 'auto',
                            mb: 12,
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Tooltip title={userFullName || ''} placement="top">
                            <IconButton
                                onClick={handleAvatarClick}
                                sx={{
                                    'display': 'flex',
                                    'width': '100%',
                                    'height': 52,
                                    'p': 0,
                                    'borderRadius': 0,
                                    'color': '#fff',
                                    '&:hover': {
                                        backgroundColor: (theme) => theme.palette.action.hover,
                                    },
                                }}
                            >
                                {loading ? (
                                    <CircularProgress size={18} sx={{color: '#fff'}} />
                                ) : img ? (
                                    <Avatar alt={userFullName} src={img}
                                            sx={{backgroundColor: 'transparent', width: 40, height: 40}} />
                                ) : (
                                    <Box
                                        sx={{
                                            width: 40,
                                            height: 40,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '1rem',
                                            color: '#fff',
                                            backgroundColor: 'transparent',
                                        }}
                                    >
                                        {initials}
                                    </Box>
                                )}
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
            );
        };
    }
}

registerBrick('0196d83d0621b7d9a53c', Sidebar);
